import React from "react";

export default class RaffleDonateLink extends React.PureComponent {
  render() {
    const {
      raffleEnrollment: { chabadHouseDonateURL, isCociSeller },
      sellerId,
    } = this.props;
    const donateURL =
      sellerId && isCociSeller
        ? "https://chabadoncampus.org/donate" //link to coci donate page when on coci-specific seller page
        : chabadHouseDonateURL;

    return donateURL ? (
      <div className="donate-link">
        <p>
          The good news is that you can still support stronger Jewish life on
          campus:
        </p>
        <a
          className="btn btn-rounded"
          href={donateURL}
          rel="noopener noreferrer"
          target="_blank"
        >
          Donate Now
          <i className="material-icons">navigate_next</i>
        </a>
      </div>
    ) : null;
  }
}
